// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 회원 탈퇴 모달 스타일 */

.withdrawal-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    animation: fadeIn 0.2s ease-out;
}

.withdrawal-modal {
    background: white;
    border-radius: 8px;
    padding: 0;
    width: 90%;
    max-width: 500px;
    max-height: calc(90vh / var(--app-zoom, 1));
    overflow-y: auto;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
    animation: slideIn 0.3s ease-out;
}

.withdrawal-modal-header {
    background: #dc3545;
    color: white;
    padding: 20px 24px;
    border-radius: 8px 8px 0 0;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.withdrawal-modal-title {
    margin: 0;
    font-size: 1.25rem;
    font-weight: 600;
}

.withdrawal-modal-close {
    background: none;
    border: none;
    color: white;
    font-size: 24px;
    cursor: pointer;
    padding: 0;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    transition: background-color 0.2s;
}

.withdrawal-modal-close:hover {
    background-color: rgba(255, 255, 255, 0.1);
}

.withdrawal-modal-form {
    padding: 24px;
}

.withdrawal-warning {
    background: #fff3cd;
    border: 1px solid #ffeaa7;
    border-radius: 6px;
    padding: 16px;
    margin-bottom: 24px;
    display: flex;
    align-items: flex-start;
    gap: 12px;
}

.warning-icon {
    font-size: 1.25rem;
    flex-shrink: 0;
}

.warning-text {
    color: #856404;
    font-size: 0.95rem;
    line-height: 1.5;
}

.form-group {
    margin-bottom: 20px;
}

.form-label {
    display: block;
    margin-bottom: 8px;
    font-weight: 500;
    color: #374151;
    font-size: 0.95rem;
}

.form-input {
    width: 100%;
    padding: 12px 16px;
    border: 2px solid #d1d5db;
    border-radius: 6px;
    font-size: 1rem;
    transition: border-color 0.2s, box-shadow 0.2s;
    box-sizing: border-box;
}

.form-input:focus {
    outline: none;
    border-color: #dc3545;
    box-shadow: 0 0 0 3px rgba(220, 53, 69, 0.1);
}

.form-input:disabled {
    background-color: #f9fafb;
    color: #6b7280;
    cursor: not-allowed;
}

.error-message {
    background: #fef2f2;
    border: 1px solid #fecaca;
    border-radius: 6px;
    padding: 12px;
    margin-top: 16px;
    display: flex;
    align-items: flex-start;
    gap: 8px;
}

.error-icon {
    color: #dc2626;
    font-size: 1rem;
    flex-shrink: 0;
}

.error-text {
    color: #dc2626;
    font-size: 0.9rem;
    line-height: 1.4;
}

.success-message {
    background: #f0fdf4;
    border: 1px solid #bbf7d0;
    border-radius: 6px;
    padding: 12px;
    margin-top: 16px;
    display: flex;
    align-items: flex-start;
    gap: 8px;
}

.success-icon {
    color: #16a34a;
    font-size: 1rem;
    flex-shrink: 0;
}

.success-text {
    color: #16a34a;
    font-size: 0.9rem;
    line-height: 1.4;
}

.withdrawal-modal-buttons {
    display: flex;
    gap: 12px;
    margin-top: 24px;
    justify-content: flex-end;
}

.withdrawal-button {
    padding: 12px 24px;
    border: none;
    border-radius: 6px;
    font-size: 0.95rem;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s;
    min-width: 100px;
}

.withdrawal-button.danger {
    background: #dc3545;
    color: white;
}

.withdrawal-button.danger:hover:not(:disabled) {
    background: #c82333;
    transform: translateY(-1px);
}

.withdrawal-button.secondary {
    background: #6c757d;
    color: white;
}

.withdrawal-button.secondary:hover:not(:disabled) {
    background: #5a6268;
    transform: translateY(-1px);
}

.withdrawal-button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none !important;
}

/* 확인 단계 스타일 */
.withdrawal-confirm {
    padding: 24px;
}

.confirm-warning {
    background: #fef2f2;
    border: 2px solid #fecaca;
    border-radius: 6px;
    padding: 20px;
    margin-bottom: 24px;
    display: flex;
    align-items: flex-start;
    gap: 16px;
}

.confirm-warning .warning-icon {
    font-size: 1.5rem;
    color: #dc2626;
}

.confirm-warning .warning-text {
    color: #dc2626;
    font-size: 1rem;
    line-height: 1.6;
}

.confirm-info {
    background: #f8f9fa;
    border: 1px solid #e9ecef;
    border-radius: 6px;
    padding: 20px;
    margin-bottom: 24px;
}

.confirm-info p {
    margin: 0 0 12px 0;
    color: #495057;
    font-size: 0.95rem;
}

.confirm-info p:last-child {
    margin-bottom: 8px;
}

.confirm-info ul {
    margin: 8px 0 0 0;
    padding-left: 20px;
    color: #6c757d;
    font-size: 0.9rem;
}

.confirm-info li {
    margin-bottom: 4px;
}

/* 애니메이션 */
@keyframes fadeIn {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

@keyframes slideIn {
    from {
        opacity: 0;
        transform: translateY(-20px) scale(0.95);
    }
    to {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
}

/* 반응형 디자인 */
@media (max-width: 640px) {
    .withdrawal-modal {
        width: 95%;
        margin: 10px;
    }

    .withdrawal-modal-header {
        padding: 16px 20px;
    }

    .withdrawal-modal-title {
        font-size: 1.1rem;
    }

    .withdrawal-modal-form,
    .withdrawal-confirm {
        padding: 20px;
    }

    .withdrawal-modal-buttons {
        flex-direction: column;
    }

    .withdrawal-button {
        width: 100%;
        padding: 14px 24px;
    }

    .confirm-warning {
        padding: 16px;
    }

    .confirm-info {
        padding: 16px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/WithdrawalModal.css"],"names":[],"mappings":"AAAA,iBAAiB;;AAEjB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,+BAA+B;AACnC;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,gBAAgB;IAChB,2CAA2C;IAC3C,gBAAgB;IAChB,yCAAyC;IACzC,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,0BAA0B;IAC1B,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,eAAe;IACf,UAAU;IACV,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,iCAAiC;AACrC;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,8CAA8C;IAC9C,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,4CAA4C;AAChD;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA,cAAc;AACd;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA,UAAU;AACV;IACI;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,UAAU;QACV,wCAAwC;IAC5C;IACA;QACI,UAAU;QACV,iCAAiC;IACrC;AACJ;;AAEA,YAAY;AACZ;IACI;QACI,UAAU;QACV,YAAY;IAChB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;;QAEI,aAAa;IACjB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;QACX,kBAAkB;IACtB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;AACJ","sourcesContent":["/* 회원 탈퇴 모달 스타일 */\r\n\r\n.withdrawal-modal-overlay {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    background-color: rgba(0, 0, 0, 0.5);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    z-index: 1000;\r\n    animation: fadeIn 0.2s ease-out;\r\n}\r\n\r\n.withdrawal-modal {\r\n    background: white;\r\n    border-radius: 8px;\r\n    padding: 0;\r\n    width: 90%;\r\n    max-width: 500px;\r\n    max-height: calc(90vh / var(--app-zoom, 1));\r\n    overflow-y: auto;\r\n    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);\r\n    animation: slideIn 0.3s ease-out;\r\n}\r\n\r\n.withdrawal-modal-header {\r\n    background: #dc3545;\r\n    color: white;\r\n    padding: 20px 24px;\r\n    border-radius: 8px 8px 0 0;\r\n    position: relative;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n}\r\n\r\n.withdrawal-modal-title {\r\n    margin: 0;\r\n    font-size: 1.25rem;\r\n    font-weight: 600;\r\n}\r\n\r\n.withdrawal-modal-close {\r\n    background: none;\r\n    border: none;\r\n    color: white;\r\n    font-size: 24px;\r\n    cursor: pointer;\r\n    padding: 0;\r\n    width: 30px;\r\n    height: 30px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    border-radius: 4px;\r\n    transition: background-color 0.2s;\r\n}\r\n\r\n.withdrawal-modal-close:hover {\r\n    background-color: rgba(255, 255, 255, 0.1);\r\n}\r\n\r\n.withdrawal-modal-form {\r\n    padding: 24px;\r\n}\r\n\r\n.withdrawal-warning {\r\n    background: #fff3cd;\r\n    border: 1px solid #ffeaa7;\r\n    border-radius: 6px;\r\n    padding: 16px;\r\n    margin-bottom: 24px;\r\n    display: flex;\r\n    align-items: flex-start;\r\n    gap: 12px;\r\n}\r\n\r\n.warning-icon {\r\n    font-size: 1.25rem;\r\n    flex-shrink: 0;\r\n}\r\n\r\n.warning-text {\r\n    color: #856404;\r\n    font-size: 0.95rem;\r\n    line-height: 1.5;\r\n}\r\n\r\n.form-group {\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.form-label {\r\n    display: block;\r\n    margin-bottom: 8px;\r\n    font-weight: 500;\r\n    color: #374151;\r\n    font-size: 0.95rem;\r\n}\r\n\r\n.form-input {\r\n    width: 100%;\r\n    padding: 12px 16px;\r\n    border: 2px solid #d1d5db;\r\n    border-radius: 6px;\r\n    font-size: 1rem;\r\n    transition: border-color 0.2s, box-shadow 0.2s;\r\n    box-sizing: border-box;\r\n}\r\n\r\n.form-input:focus {\r\n    outline: none;\r\n    border-color: #dc3545;\r\n    box-shadow: 0 0 0 3px rgba(220, 53, 69, 0.1);\r\n}\r\n\r\n.form-input:disabled {\r\n    background-color: #f9fafb;\r\n    color: #6b7280;\r\n    cursor: not-allowed;\r\n}\r\n\r\n.error-message {\r\n    background: #fef2f2;\r\n    border: 1px solid #fecaca;\r\n    border-radius: 6px;\r\n    padding: 12px;\r\n    margin-top: 16px;\r\n    display: flex;\r\n    align-items: flex-start;\r\n    gap: 8px;\r\n}\r\n\r\n.error-icon {\r\n    color: #dc2626;\r\n    font-size: 1rem;\r\n    flex-shrink: 0;\r\n}\r\n\r\n.error-text {\r\n    color: #dc2626;\r\n    font-size: 0.9rem;\r\n    line-height: 1.4;\r\n}\r\n\r\n.success-message {\r\n    background: #f0fdf4;\r\n    border: 1px solid #bbf7d0;\r\n    border-radius: 6px;\r\n    padding: 12px;\r\n    margin-top: 16px;\r\n    display: flex;\r\n    align-items: flex-start;\r\n    gap: 8px;\r\n}\r\n\r\n.success-icon {\r\n    color: #16a34a;\r\n    font-size: 1rem;\r\n    flex-shrink: 0;\r\n}\r\n\r\n.success-text {\r\n    color: #16a34a;\r\n    font-size: 0.9rem;\r\n    line-height: 1.4;\r\n}\r\n\r\n.withdrawal-modal-buttons {\r\n    display: flex;\r\n    gap: 12px;\r\n    margin-top: 24px;\r\n    justify-content: flex-end;\r\n}\r\n\r\n.withdrawal-button {\r\n    padding: 12px 24px;\r\n    border: none;\r\n    border-radius: 6px;\r\n    font-size: 0.95rem;\r\n    font-weight: 500;\r\n    cursor: pointer;\r\n    transition: all 0.2s;\r\n    min-width: 100px;\r\n}\r\n\r\n.withdrawal-button.danger {\r\n    background: #dc3545;\r\n    color: white;\r\n}\r\n\r\n.withdrawal-button.danger:hover:not(:disabled) {\r\n    background: #c82333;\r\n    transform: translateY(-1px);\r\n}\r\n\r\n.withdrawal-button.secondary {\r\n    background: #6c757d;\r\n    color: white;\r\n}\r\n\r\n.withdrawal-button.secondary:hover:not(:disabled) {\r\n    background: #5a6268;\r\n    transform: translateY(-1px);\r\n}\r\n\r\n.withdrawal-button:disabled {\r\n    opacity: 0.6;\r\n    cursor: not-allowed;\r\n    transform: none !important;\r\n}\r\n\r\n/* 확인 단계 스타일 */\r\n.withdrawal-confirm {\r\n    padding: 24px;\r\n}\r\n\r\n.confirm-warning {\r\n    background: #fef2f2;\r\n    border: 2px solid #fecaca;\r\n    border-radius: 6px;\r\n    padding: 20px;\r\n    margin-bottom: 24px;\r\n    display: flex;\r\n    align-items: flex-start;\r\n    gap: 16px;\r\n}\r\n\r\n.confirm-warning .warning-icon {\r\n    font-size: 1.5rem;\r\n    color: #dc2626;\r\n}\r\n\r\n.confirm-warning .warning-text {\r\n    color: #dc2626;\r\n    font-size: 1rem;\r\n    line-height: 1.6;\r\n}\r\n\r\n.confirm-info {\r\n    background: #f8f9fa;\r\n    border: 1px solid #e9ecef;\r\n    border-radius: 6px;\r\n    padding: 20px;\r\n    margin-bottom: 24px;\r\n}\r\n\r\n.confirm-info p {\r\n    margin: 0 0 12px 0;\r\n    color: #495057;\r\n    font-size: 0.95rem;\r\n}\r\n\r\n.confirm-info p:last-child {\r\n    margin-bottom: 8px;\r\n}\r\n\r\n.confirm-info ul {\r\n    margin: 8px 0 0 0;\r\n    padding-left: 20px;\r\n    color: #6c757d;\r\n    font-size: 0.9rem;\r\n}\r\n\r\n.confirm-info li {\r\n    margin-bottom: 4px;\r\n}\r\n\r\n/* 애니메이션 */\r\n@keyframes fadeIn {\r\n    from {\r\n        opacity: 0;\r\n    }\r\n    to {\r\n        opacity: 1;\r\n    }\r\n}\r\n\r\n@keyframes slideIn {\r\n    from {\r\n        opacity: 0;\r\n        transform: translateY(-20px) scale(0.95);\r\n    }\r\n    to {\r\n        opacity: 1;\r\n        transform: translateY(0) scale(1);\r\n    }\r\n}\r\n\r\n/* 반응형 디자인 */\r\n@media (max-width: 640px) {\r\n    .withdrawal-modal {\r\n        width: 95%;\r\n        margin: 10px;\r\n    }\r\n\r\n    .withdrawal-modal-header {\r\n        padding: 16px 20px;\r\n    }\r\n\r\n    .withdrawal-modal-title {\r\n        font-size: 1.1rem;\r\n    }\r\n\r\n    .withdrawal-modal-form,\r\n    .withdrawal-confirm {\r\n        padding: 20px;\r\n    }\r\n\r\n    .withdrawal-modal-buttons {\r\n        flex-direction: column;\r\n    }\r\n\r\n    .withdrawal-button {\r\n        width: 100%;\r\n        padding: 14px 24px;\r\n    }\r\n\r\n    .confirm-warning {\r\n        padding: 16px;\r\n    }\r\n\r\n    .confirm-info {\r\n        padding: 16px;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
